import React, { useMemo } from 'react';
import { FeatureFlagsContext } from '../feature-flags.context';
import { useFeatureFlags } from '../hooks/use-feature-flags.hook';

type FeatureFlagsProviderProps = React.PropsWithChildren;

export const FeatureFlagsProvider: React.FC<FeatureFlagsProviderProps> = ({ children }) => {
    const { featureFlags, isLoading } = useFeatureFlags();

    const value = useMemo(
        () => ({
            featureFlags,
            isLoading,
        }),
        [featureFlags, isLoading]
    );

    return <FeatureFlagsContext.Provider value={value}>{children}</FeatureFlagsContext.Provider>;
};
